import axios from 'axios';
import { getCookie, setCookie, deleteCookie } from './utils';
import { addApiResponse } from './redux/apiSlice';
import store from './redux/store';

let isRefreshing = false;
let refreshSubscribers = [];

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const api = axios.create({
  baseURL: `${BASE_URL}`,
});

api.interceptors.request.use(
  (config) => {
    const accessToken = getCookie('accessToken');
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
      store.dispatch(
      addApiResponse({
        endpoint: response.config.url,
        response: response.data,
      })
    );

    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    /**if (error.response.data.status == 'Error') {
        deleteCookie('refreshToken');
        deleteCookie('accessToken');
        window.location.href = '/admin/login';
    }**/

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      if (error.response.data.error == "Unauthenticated") {
         deleteCookie('refreshToken');
         deleteCookie('accessToken');
         window.location.href = '/login';         
      }

      try {
        const refreshToken = getCookie('refreshToken');
        if (!refreshToken || refreshToken == '') {
          return Promise.reject(error);
        }

        if (!isRefreshing) {
          isRefreshing = true;
          const response = await axios.post(`${BASE_URL}/refresh-token`, {
            refresh_token: refreshToken,
          }, {
            headers: {
              'Content-Type': 'application/json',
            }
          });
          const newAccessToken = response.data.data.access_token;
          const newRefreshToken = response.data.data.refresh_token;
          setCookie('accessToken', newAccessToken, 30);
          setCookie('refreshToken', newRefreshToken, 30);
          originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
          isRefreshing = false;
          refreshSubscribers.forEach(callback => callback(newAccessToken));
          refreshSubscribers = [];
          return api(originalRequest);
        } else {
          return new Promise((resolve) => {
            refreshSubscribers.push((accessToken) => {
              originalRequest.headers.Authorization = `Bearer ${accessToken}`;
              resolve(api(originalRequest));
            });
          });
        }
      } catch (refreshError) { 
        deleteCookie('refreshToken');
        deleteCookie('accessToken');

        if (localStorage.hasOwnProperty('user_type')) {
          if (localStorage.getItem('user_type') == 'admin') {
            window.location.href = '/admin/login';
          }
          if (localStorage.getItem('user_type') == 'customer') {
            window.location.href = '/customer/login';
          }
          
        } else {
          window.location.href = '/';
        } 
        
        console.error('Error refreshing token:', refreshError);
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default api;